<script setup lang="ts">
import { ref, watch } from '#imports';

const props = defineProps({
  fadeRight: {
    type: Boolean,
    default: false,
  },
  showControls: {
    type: Boolean,
    default: false,
  },
  showInlineControl: {
    type: Boolean,
    default: false,
  },
});

const content = ref<HTMLElement | null>(null);
const showBackwardsControl = ref(false);
const showFowardsControl = ref(true);
const scrollAmount = ref(0)
const scrollPos = ref(0)
const scrollContent = (direction: 'left' | 'right') => {
  if (!content.value) return;
  if (scrollPos.value > content.value.offsetWidth && direction === 'right') return;
  scrollAmount.value = content.value.offsetWidth / 2;
  content.value.scrollLeft +=
    direction === 'left' ? -scrollAmount.value : scrollAmount.value;
  scrollPos.value +=
    direction === 'left' ? -scrollAmount.value : scrollAmount.value;
};

watch(scrollPos, () => {
  if (scrollPos.value > 0) {
    showBackwardsControl.value = true;
  } else {
    showBackwardsControl.value = false;
  }
  if (scrollPos.value > content?.value?.offsetWidth) {
    showFowardsControl.value = false;
  } else {
    showFowardsControl.value = true;
  }
});

</script>

<template>
  <div :class="['swipe-container', props.fadeRight ? 'fade-right' : '', props.showControls ? 'show-controls' : '']">
  <div v-if="props.showControls" class="slider-controls">
    <button class="arrow-button arrow-left" @click="scrollContent('left')">
      <i class="ri-arrow-left-s-line"></i>
    </button>
    <button class="arrow-button arrow-right" @click="scrollContent('right')">
      <i class="ri-arrow-right-s-line"></i>
    </button>
  </div>
    <div class="swipe-content" ref="content">
      <slot />
    </div>
    <div v-if="props.showInlineControl" class="inline-controls">
      <button v-if="showBackwardsControl" class="arrow-button arrow-left" @click="scrollContent('left')">
        <i class="ri-arrow-left-s-line"></i>
      </button>
      <button v-if="showFowardsControl" class="arrow-button arrow-right" @click="scrollContent('right')">
        <i class="ri-arrow-right-s-line"></i>
      </button>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import 'assets/css/breakpoints.pcss';
.swipe-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.swipe-container.show-controls {
  padding-bottom: 2.5rem;
}

.swipe-content {
  display: inline-flex;
  align-items: baseline;
  gap: inherit;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  min-height: fit-content;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 0.385rem 0.175rem 0.25rem;
  scroll-behavior: smooth;
}
.swipe-content::-webkit-scrollbar {
  display: none;
}
.swipe-content > * {
  flex: 0 0 auto;
  scroll-snap-align: start;
}

.fade-right:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 8rem;
  height: 100%;
}

@media (max-width: 768px) {
  .swipe-container {
    scroll-behavior: smooth;
  }
}

.slider-controls {
  position: absolute;
  bottom: 0rem;
  right: 1rem;
  display: flex;
  z-index: 10;
  pointer-events: none;
  gap: 1rem;
  transition: margin-right 0.3s ease;

  @media (min-width: 768px) {
    right: 0;
  }
}

.arrow-button {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  pointer-events: auto;
}

.arrow-button:hover {
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.inline-controls {
  display: none;
  @mixin screen md {
    display: flex;
    z-index: 10;
    .arrow-button {
      border-radius: 0.5rem;
    }
    .arrow-right {
      position: absolute;
      top: 0.25rem;
      right: 0;
    }
    .arrow-left {
      position: absolute;
      top: 0.25rem;
      left: 0;
    }
  }
}
</style>
